// @flow
import $ from 'jquery';
import HttpJob from './HttpJob';
import t from '../i18n/I18n';
const debug = require('../debug/debug')('wc:protocol:FetchJsonJob');

export default class FetchJsonJob extends HttpJob {
  _url: string;

  constructor(url: string, preResolve: ?Function, preReject: ?Function) {
    super();
    this._url = url;
    this._promise = new Promise((resolve, reject) => {
      this._xhr = $.ajax({
        contentType: false,
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: 'GET',
        url
      })
        .done((...args) => {
          debug('job success');
          if (preResolve) {
            return resolve(preResolve(...args));
          }

          return resolve(...args);
        })
        .fail((...args) => {
          debug('job error: ', args);
          if (preReject) {
            return reject(preReject(...args));
          }

          return reject(...args);
        })
        .always(() => (this._done = true));
    });
  }

  get url() {
    return this._url;
  }

  get description() {
    const desc = super.description;
    return {
      label: `${t('LOADING_DATA_FROM_SERVER')} (${desc.status})`,
      tooltip: `URL: ${this._url}`,
      status: desc.status
    };
  }
}
